module.exports = __webpack_public_path__ + "img/qatar-logo-icon.c352f548.png";